import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchDropdown } from '../../../actions/actionCreators';
import { renderSearchDropDown } from '../../common/form/FieldHelper';

class IntegrationTypeDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      onPostChange,
      listOptions,
      isFix,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="integration_type"
          type="integration_type"
          valueField="id"
          listOptions={listOptions}
          component={renderSearchDropDown}
          onPostChange={onPostChange}
          isFix={isFix}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch,
  );
}
IntegrationTypeDropdown = connect(
  null,
  mapDispatchToProps,
)(IntegrationTypeDropdown);
export default IntegrationTypeDropdown;
